import React from 'react';
import {MasterLayout} from 'layout';
import {DanhSachKeHoachThanhTra} from 'modules/thanh-tra';

export default class DanhSachThanhTraPage extends React.Component {

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <DanhSachKeHoachThanhTra/>
      </MasterLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/thanh-tra/DanhSachThanhTraPage.jsx